import type { ReactNode } from 'react';
import {
  IconCompany,
} from '../components/NavIcons';

export type NavItem = {
  to: string;
  label: string;
  end?: boolean;
  icon: (p: { className?: string }) => ReactNode;
};

export type NavSection = {
  id: 'companies';
  title: string;
  dot: string;
  items: NavItem[];
};

/** One analyst workspace entry; company tools live inside each company workspace. */
export const NAV_SECTIONS: NavSection[] = [
  {
    id: 'companies',
    title: 'Companies',
    dot: '#7ef0c4',
    items: [{ to: '/companies', label: 'Companies', icon: IconCompany }],
  },
];

export const HOME_PATH = '/companies';
